import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=f6213cca&"
import script from "./Caption.vue?vue&type=script&lang=js&"
export * from "./Caption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports